import * as React from 'react';

import qs from 'qs';

import useIframePostMessage from 'hooks/useIframePostMessage';
import withEcomAwareIframe from 'pages/utils/withEcomAwareIframe';
import withLocaleAwareIframe from 'pages/utils/withLocaleAwareIframe';
import withLocalizeAwareIframe from 'pages/utils/withLocalizeAwareIframe';
import withRouteAwareIframe from 'pages/utils/withRouteAwareIframe';
import withValidSessionIframe from 'pages/utils/withValidSessionIframe';

import { paths } from './routes';

const GiftCardsIframe: React.FC = () => {
  const target = window.isGriffin() ? '_self' : '_blank';

  const message = {
    type: 'setRetailLinkTarget',
    payload: { target },
  };

  const { iframeRef } = useIframePostMessage({ message });

  const segment = window.location.pathname.replace(paths.giftCards, '');

  const query = qs.stringify(
    {
      shopId: window.merchantos?.session?.sessData?.Shop?.shopID,
      // eslint-disable-next-line camelcase
      currencyCode: window.merchantos?.locale?.currency_code,
      hasRetailIntegration: true,
      shopName: window.merchantos?.session?.sessData?.Shop?.name,
    },
    { addQueryPrefix: true }
  );

  return (
    <>
      <style
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: `.react-page { height: 100% }`,
        }}
      />
      <iframe
        ref={iframeRef}
        src={`/webapps_redirect.php?app=omni-gift-card&next=${segment}${encodeURIComponent(query)}`}
        style={{ border: 'none', width: '100%', height: '100%', display: 'block' }}
        title="Gift Cards"
      />
    </>
  );
};

export default withEcomAwareIframe(
  withLocalizeAwareIframe(
    withLocaleAwareIframe(withRouteAwareIframe(withValidSessionIframe(GiftCardsIframe)))
  )
);
